const isPwcAcs = (organizationName?: string) => (
  organizationName?.toLowerCase() === "pwc-acs"
);

export default isPwcAcs;
